import _ from 'lodash';
import { SocketContext } from '../../components/socketLib/ConnectorSocket'
import { useContext } from 'react';
import { get, getFile, post } from './httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';

/*Это файл с тестовыми данными для dnd меню а так же бриджом для запросов в кор.
Drag and drop имеет следующую структуру

./src
    ./api
        ./apiBridges 
            ./dndBridge.js  (Бриджи для дескриптора)
        ./descriptors
            ./addressableStorage.js (Дескрипторы)
    ./components
        ./DragDrop.js (Основной элемент drag end drop)
    ./utils
        ./dndutils
            ./cardformatters.js (Форматеры тикетов)
            ./containerformatters.js  (Форматеры контейнеров)
            ./staticresorces.js (Статические ресурсы)
            ./toppanelformaters.js  (Форматеры панелей фильтров)

Для создания нового элемента он размещается в соответствующем файле, после чего вкладывается в дескриптор, который работает как конструктор для данного меню
*/

let dataNewClientsCards = [
  {
      id: '1393',
      content: { date:new Date(), managers:[{src:'none', id:'1'}]},
      number: '+8 (800) 555-35-35',
      status: '1'
  },
  {
      id:'1245',
      content: {date:new Date(), managers:[{src:'none', id:'1'}]},
      number: '+7 (914) 222-12-22',
      status: '2'
  },
  {
      id:'6753', 
      content: {date:new Date(), managers:[{src:'none', id:'1'}]},
      number: '+7 (924) 345-12-78',
      status: '3'
  },
  {
      id:'1164', 
      content: {date:new Date(), managers:[{src:'none', id:'1'}]},
      number: '+7 (964) 712-78-58',
      status: '4'
  },
];


let dataMyClientsCards = [
  {
      id: '1393',
      content: { date:new Date(), managers:[{src:'none', id:'1'}]},
      name:'Aquawater OmnyHomyyyy MyboyMan',
      number: '+7 (999) 888-88-88',
      maill:'somepochta@mail.ru',
      dealcount:38,
      state:'Unknown',
      status: '1'
  },
  {
      id:'1245',
      content: {date:new Date(), managers:[{src:'none', id:'1'}]},
      name:'Barry Alen', number: '+7 (999) 888-88-88', maill:'nasomepochta@mail.ru', dealcount:18, state:'Emerald', 
      status: '2'
  },
  {
      id:'6753', 
      content: {date:new Date(), managers:[{src:'none', id:'1'}]},
      name:'Green Lantern', number: '+7 (999) 888-88-88', maill:'prisomepochta@mail.ru', dealcount:21, state:'Argent', 
      status: '3'
  },
  {
      id:'1164', 
      content: {date:new Date(), managers:[{src:'none', id:'1'}]},
      name:'Bruse Vain', number: '+7 (999) 888-88-88', maill:'nesomepochta@mail.ru', dealcount:11, state:'Gold', 
      status: '4'
  },
];

let dataPicUpGoodsCards = [
  {
      id:'71261', 
      name: 'Ольга', 
      state:'Emerald', 
      content: {deal_number:'71263678', units:10, sku:10, start_date:'18 июнь', end_date:new Date(), date:new Date(), managers:[{src:'none', id:'1'}]},
      status: '1'
  },
  {
      id:'74621', 
      name: 'София', 
      state:'Gold', 
      content: {deal_number:'12234532', units:20, sku:20, start_date:'18 июнь', end_date:new Date(), date:new Date(), managers:[{src:'none', id:'1'},{src:'none', id:'2'}]},
      status: '2'
  },
  {
      id:'12057', 
      name: 'Ангелина',
      state:'Argent',
      content: { deal_number:'75621343', units:12, sku:12, start_date:'18 июнь', end_date:new Date(), date:new Date(), managers:[{src:'none', id:'1'}, {src:'none', id:'2'},{src:'none', id:'3'}]},
      status: '3'
  },
  {
      id:'97453', 
      name: 'Бебурка', 
      state:'Unknown', 
      content: {deal_number:'96724562', units:9, sku:9, start_date:'18 июнь', end_date:new Date(), date:new Date(), managers:[{src:'none', id:'1'}]},
      status: '4'
  },
];


let nesteddataPicUpGoodsCards = [
  {
      id:'71261', 
      name: 'Ольга', 
      state:'Emerald', 
      content: {deal_number:'71263678', units:10, sku:10,start_date:'18 июнь', end_date:new Date(), date:new Date(), managers:[{src:'none', id:'1'}]},
      status: '1_1'
  },
  {
      id:'74621', 
      name: 'София', 
      state:'Gold', 
      content: {deal_number:'12234532', units:20, sku:20, start_date:'18 июнь', end_date:new Date(), date:new Date(), managers:[{src:'none', id:'1'},{src:'none', id:'2'}]},
      status: '1_2'
  },
  {
      id:'12057', 
      name: 'Ангелинанана', 
      state:'Argent', 
      content: {deal_number:'75621343', units:12, sku:12, start_date:'18 июнь', end_date:new Date(), date:new Date(), managers:[{src:'none', id:'1'}, {src:'none', id:'2'},{src:'none', id:'3'}]},
      status: '2_1'
  },
  {
      id:'97453', 
      name: 'Бебурка', 
      state:'Unknown', 
      content: {deal_number:'96724562', units:9, sku:9, start_date:'18 июнь', end_date:new Date(), date:new Date(), managers:[{src:'none', id:'1'}]},
      status: '2_1'
  },
];


let nestedtypesHero = [{status:'1', name:'Подмышка сатаны', color:'#e0e0e0', colorcircule:'#D0D0D0', items:[{name:'1', status:'1_1', color:'#e0e0e0', colorcircule:'#D0D0D0'}, {name:'2', status:'1_2', color:'#e0e0e0', colorcircule:'#D0D0D0'}]}, {status:'2', color:'#e0e0e0', colorcircule:'#D0D0D0', name:'Рюкзак хитчхайкера', items:[{name:'1', status:'2_1', color:'#e0e0e0', colorcircule:'#D0D0D0'}, {name:'2', status:'2_2', color:'#e0e0e0', colorcircule:'#D0D0D0'}]}]

let dataNewClientsShow = ['1393','1245','6753','1164'];

let dataPicUpGoodsShow = ['71261', '74621', '12057', '97453'];

let nesteddataPicUpGoodsShow = ['71261', '74621', '12057', '97453'];

// Бридж для запросов в кор. Вкладывается в дескриптор
// Имена методов бриджа соответствуют именам дескрипторов. Сделано для того чтобы можно было использовать их в режиме конструктора
export default function Bridge() {
    
    const { socket } = useContext(SocketContext);
    const { user_id, company_id, rules } = useSelector(
            loginSelector
          );

    const my_clients_tabs = [
        {name:'Без статуса', status:'Unknown', color:'#f6f6f6', colorcircule:'#c5c5c5'}, 
        {name:'Серебряные', status:'Argent', color:'#b2bdbf', colorcircule:'#88a1ad'}, 
        {name:'Золотые', status:'Gold', color:'#ffea73', colorcircule:'#d3b755'}, 
        {name:'Изумрудные', status:'Emerald', color:'#3ca97f', 
            colorcircule:'#61c58c'
            // colorcircule:'#ff0000'
        }]

    
    return {

        //first get
        start_get_pik_goods: async () => {
            
            // const data = await get('Test/dnd_pik_goods_items')
            const data = await get('Deal/getCompanyDeals', {cid:company_id, type:"pik_goods"})
            console.log("raw items", data)
            let items = {}; 
            data.map(el =>{if (!items[el.status]) items[el.status] = {}; items[el.status][el.id] = el; return el})
            console.log("items", items)

            const tables = await get('dndTables/get', {cid:company_id, type: "pik_goods"})
            console.log("raw tables", tables)

            const order = await get('Deal/getCompanyDealsOrder', {cid:company_id, type:"pik_goods"})
            console.log("raw order", order)

            return  {items, tables, order}
        },

        start_get_moving_deals: async () => {
            
            // const data = await get('Test/dnd_pik_goods_items')
            const data = await get('Deal/getCompanyDeals', {cid:company_id, type:"moving_deals"})
            console.log("raw items", data)
            let items = {}; 
            data.map(el =>{if (!items[el.status]) items[el.status] = {}; items[el.status][el.id] = el; return el})
            console.log("items", items)

            const tables = await get('dndTables/get', {cid:company_id, type: "moving_deals"})
            console.log("raw tables", tables)

            const order = await get('Deal/getCompanyDealsOrder', {cid:company_id, type:"moving_deals"})
            console.log("raw order", order)

            return  {items, tables, order}
        },


        start_get_products_storage: async () => {
            
            const data = await get('Deal/getCompanyDealsStorage', {cid:company_id})
            console.log("raw items", data)
            let items = {}; 
            let unity = []///Дедается для того, чтобы отображать обобщенные сделки, если их еще нет в orders
            data.map(el => {
                if (!items[el.status]) items[el.status] = {}; 
                items[el.status][el.id] = el; 
                if (!parseInt(String(el.id)[0])) {unity.push(el.id)}///Дедается для того, чтобы отображать обобщенные сделки, если их еще нет в orders
                return el
            })
            console.log("items", items)

            const tables = await get('dndTables/get', {cid:company_id, type: "products_storage"})
            console.log("raw tables", tables)

            const order = await get('Deal/getCompanyDealsOrder', {cid:company_id, type:"products_storage"})
            console.log("raw order", order)
            unity.map((el) => {if (!order.includes(el)) {order.push(el)}})///Дедается для того, чтобы отображать обобщенные сделки, если их еще нет в orders

            return  {items, tables, order}
        },

        start_get_products_shipment: async () => {
            
            const data = await get('Deal/getCompanyDeals', {cid:company_id, type:"products_shipment"})
            console.log("raw items", data)
            let items = {}; 
            data.map(el =>{if (!items[el.status]) items[el.status] = {}; items[el.status][el.id] = el; return el})
            console.log("items", items)

            const tables = await get('dndTables/get', {cid:company_id, type: "products_shipment"})
            console.log("raw tables", tables)

            const order = await get('Deal/getCompanyDealsOrder', {cid:company_id, type:"products_shipment"})
            console.log("raw order", order)

            return  {items, tables, order}
        },

        start_get_adrr_storage: async () => {
            
            const data = await get('Deal/getCompanyDealsAddrs', {cid:company_id})
            console.log("raw items", data)
            let items = {}; 
            data.map(el =>{if (!items[el.status]) items[el.status] = {}; items[el.status][el.id] = el; return el})
            console.log("items", items)

            const tables = await get('dndTables/get', {cid:company_id, type: "adrr_storage"})
            console.log("raw tables", tables)

            const order = await get('Deal/getCompanyDealsOrder', {cid:company_id, type:"adrr_storage"})
            console.log("raw order", order)

            return  {items, tables, order}
        },

        tabs_get_adrr_storage: async () => {
            let data = await get("as_tabs/getOnCompany", {cid: company_id})
            return data
        },

        start_get_my_clients: async () => {
            let rawdata = []
            let order = []
            if (rules.includes("admin")) {
                rawdata = await get('Clients/getOnCompany', {cid:company_id})
                order = await get('dndTablesOrders/getManagerDNDTableOrders', {cid:company_id})
            }
            else {
                rawdata = await get('Clients/getOnMng', {mid:user_id})
                order = await get('dndTablesOrders/getManagerDNDTableOrders', {cid:company_id, user_id})
            }
            console.log("raw items", rawdata)
            const data = rawdata.message
            let items = {}; 
            await Promise.all(data.map(async (el) =>{
                if (el.data) {
                    let eldata = JSON.parse(el.data)
                    el.data=eldata
                } else {el.data = {}}
                if (!items[el.status]) items[el.status] = {}; 
                items[el.status][el.id] = el; 
            }))
            console.log("items", items)
            let tables = my_clients_tabs
            //тут используется отличный от других подход
            return  {items, tables, order}
        },


        //карточки
        get_pik_goods: () => {socket.emit('dnd_get_pik_goods');},
        set_pik_goods: (id, field, value, logData) => {
            socket.emit("dnd_set_pik_goods", {id, field, value, company_id})
            post("Logs/create", {
                deal_id:id,
                user_type:"ful",
                user_id,
                type: "change_deal_status",
                data: logData
            })
            // dataPicUpGoodsCards.map(el =>{if (el.id === id) _.set(el, field, value); return el});
            // return 'ok';
        },
        get_my_clients: () => {},
        set_my_clients: (id, field, value) => {
            socket.emit("dnd_set_my_clients", {id, field, value, user_id, company_id})
        },
        get_moving_deals: () => {},
        set_moving_deals: (id, field, value, logData) => {
            socket.emit("dnd_set_moving_deals", {id, field, value, company_id})
            post("Logs/create", {
                deal_id:id,
                user_type:"ful",
                user_id,
                type: "change_deal_status",
                data: logData
            })
        },

        get_products_storage: () => {},
        set_products_storage: (id, field, value, logData) => {
            socket.emit("dnd_set_products_storage", {id, field, value, company_id})
            post("Logs/create", {
                deal_id:id,
                user_type:"ful",
                user_id,
                type: "change_deal_status",
                data: logData
            })
        },

        get_products_shipment: () => {},
        set_products_shipment: (id, field, value, logData) => {
            socket.emit("dnd_set_products_shipment", {id, field, value, company_id})
            post("Logs/create", {
                deal_id:id,
                user_type:"ful",
                user_id,
                type: "change_deal_status",
                data: logData
            })
        },

        get_adrr_storage: () => {},
        set_adrr_storage: (id, field, value, logData) => {
            console.log("set_adrr_storage", value)
            //Так как мы передаем имя верхней таблицы в value, можем составить правильный адрес
            socket.emit("dnd_set_adrr_storage", 
                {
                    id, 
                    field:'adrst', 
                    // value: `${value.tableName[0]}-${value.status.replace('_', '-')}`, 
                    value: value.status.replaceAll('_', '-'),
                    company_id
                })
            //По факту тут лог не нужен, так как при обновлении должен появиться
            // post("Logs/create", {
            //     deal_id:id,
            //     user_type:"ful",
            //     user_id,
            //     type: "change_deal_status",
            //     data: logData
            // })
        },

        //Воронки
        get_tables_pik_goods: () => {socket.emit('dnd_get_tables_pik_goods');},
        set_tables_pik_goods: (data) => {socket.emit('dnd_set_tables_pik_goods', {data, company_id});},
        get_tables_moving_deals: () => {socket.emit('dnd_get_tables_moving_deals');},
        set_tables_moving_deals: (data) => {socket.emit('dnd_set_tables_moving_deals', {data, company_id});},
        get_tables_products_storage: () => {socket.emit('dnd_get_tables_products_storage');},
        set_tables_products_storage: (data) => {socket.emit('dnd_set_tables_products_storage', {data, company_id});},
        get_tables_products_shipment: () => {socket.emit('dnd_get_tables_products_shipment');},
        set_tables_products_shipment: (data) => {socket.emit('dnd_set_tables_products_shipment', {data, company_id});},
        get_tables_adrr_storage: () => {socket.emit('dnd_get_tables_adrr_storage');},
        set_tables_adrr_storage: (data) => {console.log("SET SUCCESS");socket.emit('dnd_set_tables_adrr_storage', {data, company_id});},
        
        set_tabs_adrr_storage: (data) => {socket.emit('dnd_set_tabs_adrr_storage', {data, company_id});},

        get_tables_my_clients: () => {return my_clients_tabs},
        
        // //порядок компонентов todo
        set_order_pik_goods: (data) => {console.log("set_order_pik_goods", data);socket.emit('dnd_set_order_pik_goods', {company_id, list:data, type:"pik_goods"});},
        set_order_moving_deals: (data) => {socket.emit('dnd_set_order_moving_deals', {company_id, list:data, type:"moving_deals"});},
        set_order_products_storage: (data) => {socket.emit('dnd_set_order_products_storage', {company_id, list:data, type:"products_storage"});},
        set_order_products_shipment: (data) => {socket.emit('dnd_set_order_products_shipment', {company_id, list:data, type:"products_shipment"});},
        set_order_my_clients: (data) => {socket.emit('dnd_set_order_my_clients', {company_id, list:data, type:"my_clients"});},
        set_order_adrr_storage: (data) => {socket.emit('dnd_set_order_adrr_storage', {company_id, list:data, type:"adrr_storage"});},
    }

    return {
        //Карточки
        // get_my_clients: () => { let resp = {}; dataMyClientsCards.map(el =>{if (!resp[el.status]) resp[el.status] = {}; resp[el.status][el.id] = el; return el}); return resp;},
        get_pik_goods: () => { let resp = {}; dataPicUpGoodsCards.map(el =>{if (!resp[el.status]) resp[el.status] = {}; resp[el.status][el.id] = el; return el}); return resp;},
        
        get_adrr_storage: () => {let resp = {}; nesteddataPicUpGoodsCards.map(el =>{if (!resp[el.status]) resp[el.status] = {}; resp[el.status][el.id] = el; return el}); return resp;},
        get_new_clients: () => {let resp = {}; dataNewClientsCards.map(el =>{if (!resp[el.status]) resp[el.status] = {}; resp[el.status][el.id] = el; return el}); return resp;},
        
        set_my_clients: (id, field, value) => {dataMyClientsCards.map(el =>{if (el.id === id) _.set(el, field, value); return el}); return 'ok';},
        set_pik_goods: (id, field, value) => {dataPicUpGoodsCards.map(el =>{if (el.id === id) _.set(el, field, value); return el}); return 'ok';},
        set_adrr_storage: (id, field, value) => {nesteddataPicUpGoodsCards.map(el =>{if (el.id === id) _.set(el, field, value); return el}); return 'ok';},
        set_new_clients: (id, field, value) => {dataNewClientsCards.map(el =>{if (el.id === id) _.set(el, field, value); return el}); return 'ok';},

        //воронки
        // get_tables_my_clients: () => {return typesHero;},
        // get_tables_pik_goods: () => {return typesHero;},
        get_tables_pik_goods: () => {console.log("step2"); socket.emit('dnd_get_tables_pik_goods');},
        get_tables_adrr_storage: () => {return nestedtypesHero;},
        // get_tables_new_clients: () => {return typesHero;},

        // set_tables_my_clients: (data) => {typesHero = data;},
        // set_tables_pik_goods: (data) => {typesHero = data;},
        set_tables_adrr_storage: (data) => {nestedtypesHero = data;},
        // set_tables_new_clients: (data) => {typesHero = data;},

        //отоброжаемые компоненты
        get_order_my_clients: () => {return dataNewClientsShow;},
        get_order_pik_goods: () => {return dataPicUpGoodsShow;},
        get_order_adrr_storage: () => {return nesteddataPicUpGoodsShow;},
        get_order_new_clients: () => {return dataNewClientsShow;},

        set_order_my_clients: (data) => {dataNewClientsShow = data;},
        set_order_pik_goods: (data) => {dataPicUpGoodsShow = data;},
        set_order_adrr_storage: (data) => {nesteddataPicUpGoodsShow = data;},
        set_order_new_clients: (data) => {dataNewClientsShow = data;},
    };
  }